import { Injectable } from "@angular/core";
import { USER_ALLOC_UPLOAD_FOLDERNAME, RECIPIENT_ALLOC_UPLOAD_FOLDERNAME } from "src/app/utils/constant";
import { UploadColumnErrorComponent } from "../dialog/upload-column-error/upload-column-error.component";
import { FormControl, ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";
import { LanguageService } from "../language/language.service";
import { environment } from "src/environments/environment";
import { DialogService } from "../dialog/dialog.service";
import { ConfirmDialogComponent } from 'src/app/services/dialog/confirm-dialog/confirm-dialog.component';
import { S3Service } from "../s3/s3.service";
import { BehaviorSubject, Observable } from "rxjs";
import * as moment from 'moment';
import * as mtz from 'moment-timezone';
import * as XLSX from 'xlsx';
import * as _ from "lodash";
import { OtpDialogComponent } from "../dialog/otp-dialog/otp-dialog.component";
// import { _MatToolbarMixinBase } from "@angular/material";

@Injectable({
  providedIn: "root"
})
export class HelperService {
  public fileToUpload: File;
  public hasUploaded: BehaviorSubject<any> = new BehaviorSubject('');

  constructor(
    private s3: S3Service,
    private dialogService: DialogService,
    private languageService: LanguageService,
  ) { }

  // public initLocale(){
  //   let langs = _.map(LANGUAGES, 'value');
  //   this.translate.addLangs(langs);

  //   this.translate.setDefaultLang(DEFAULT_LANGUAGE);

  //   let lang;

  //   if(localStorage.getItem(KEY_STORAGE_LANGUAGE)){
  //     lang = localStorage.getItem(KEY_STORAGE_LANGUAGE);
  //   } else {
  //     if(_.indexOf(langs, this.translate.getBrowserLang()) >= 0){
  //       lang = this.translate.getBrowserLang();
  //     } else {
  //       lang = DEFAULT_LANGUAGE;
  //     }
  //     localStorage.setItem(KEY_STORAGE_LANGUAGE, DEFAULT_LANGUAGE);
  //   }

  //   this.translate.use(lang);
  // }

  // public getLocale(){
  //   return localStorage.getItem(KEY_STORAGE_LANGUAGE);
  // }

  // public updateLocale(locale){
  //   this.translate.use(locale);
  //   localStorage.setItem(KEY_STORAGE_LANGUAGE, locale);
  // }

  public randomString(n: number = 6) {
    return Math.random()
      .toString(36)
      .substring(n);
  }

  fileContent() {
    return this.fileToUpload == null ? true : false;
  }

  objectTrimmer(obj) {
    _.each(obj, (val, key) => (obj[key] = _.trim(val)));
  }

  public validateNumbersOnly(control: FormControl) {
    if (control.value) {
      let regex = new RegExp("^[0-9- ]*$")
      let result: Boolean = regex.test(control.value)
      return result ? null : { 'valid': true }
    }
  }

  public validateNumbersDecimalPoint(control: FormControl) {
    if (control.value) {
      let regex = new RegExp("^[0-9-. ]*$")
      let result: Boolean = regex.test(control.value)
      return result ? null : { 'numWithDecimal': true }
    }
  }

  public decimalTwoPlaces(control: FormControl) {
    if (control.value) {
      let regex = new RegExp("^\\s*\\d*(?:\\.\\d{0,2})?\\s*$")
      let result: Boolean = regex.test(control.value)
      return result ? null : { 'decimalErr': true };
    }
  }

  public valueGreaterThanZero(control: FormControl) {
    if (control.value) {
      return (control.value <= 0) ? { 'minZero': true } : null;
    }
  }

  public noDecimalPlaces(control: FormControl) {
    if (control.value) {
      let regex = new RegExp("^\\.?")
      let result: Boolean = regex.test(control.value);
      return result ? null : { 'noDecimal': true };
    }
  }

  public chipsRequiredValidator(control: FormControl) {
    return (!control.value || (control.value && control.value.length == 0)) ? { required: true } : null;
  }

  public displayHeader(col, moduleCode?) {
    if (moduleCode && (_.toLower(moduleCode) === 'dvm' && (_.toLower(col) == 'code'))) {
      return 'LABEL_SERIAL_NUMBER';
    }
    else if (moduleCode && (_.toLower(moduleCode) === 'dvm' && (_.toLower(col) == 'device_type'))) {
      return 'LABEL_DEVICE_TYPE';
    }
    return col;
  }

  public displayFields(row, columnName?, moduleCode?, displayMode?, descriptionOnly = false) {
    //accepts obj and key; helps transform 'is_active' field to 'status' so we can easily translate
    if (_.toLower(columnName) == 'is_active') {
      return row[columnName] == 1 ? 'LABEL_ACTIVE' : 'LABEL_INACTIVE';
    }
    else if (_.toLower(columnName) == 'web_user_role_is_active') {
      return row[columnName] == 1 ? 'LABEL_ACTIVE' : 'LABEL_INACTIVE';
    }
    else if (_.toLower(columnName) == 'terminal_is_registered') {
      return row[columnName] == 1 ? 'LABEL_YES' : 'LABEL_NO';
    }
    else if (_.toLower(columnName) == 'city') {
      return (_.get(row["province"], 'description') + ", " + _.get(row[columnName], 'description'))
    }
    else if (displayMode && moduleCode && (_.toLower(moduleCode) == 'wurm') && (_.toLower(columnName) == 'username')) {
      return row["username"] + " - " + row["full_name"]
    }
    else if (displayMode && moduleCode && (_.toLower(moduleCode) == 'wurm') && (_.toLower(columnName) == 'fullname')) {
      return (_.get(row, "reference_code") || "undefined") + " - " + row["fullname"]
    }
    else if (moduleCode && (_.toLower(moduleCode) == 'com') && (_.toLower(columnName) == 'code')) {
      return row["coupon_prefix_code"]
    }
    else if (moduleCode && (_.toLower(moduleCode) == 'cp') && (_.toLower(columnName) == 'allocated_by' || _.toLower(columnName) == 'allocated_to')) {
      if (row[columnName] == null) {
        return this.languageService.getTranslation('LABEL_UNASSIGNED', {})
      } else {
        return row[columnName]
      }
    }
    else if (moduleCode && (_.toLower(moduleCode) == 'rm' && (_.toLower(columnName) == 'max_registration'))) {
      return row[columnName] > -1 ? row[columnName] : this.languageService.getTranslation('LABEL_INFINITE', {})
    } 
    else if (_.toLower(columnName) == 'web_user_company') {
      const webUserCompanyList = row["web_user_company_list"];
      if (!webUserCompanyList || webUserCompanyList.length === 0) {
        return "";
      }

      const companyDescriptionList = webUserCompanyList
        .filter((company: any) => company) // Remove null/undefined items
        .map((company: any) => company.description)
        .filter((desc: any) => desc); // Remove null/undefined descriptions
  
      return companyDescriptionList?.join("\n") || "";
    }
    else {
      if (descriptionOnly) {
        return _.has(row[columnName], 'description') ? _.get(row[columnName], 'description') : (row[columnName] ? row[columnName] : 'Undefined');
      }

      return _.has(row[columnName], 'code') ? (_.get(row[columnName], 'code') + " - " + _.get(row[columnName], 'description')) : (row[columnName] ? row[columnName] : 'Undefined');
    }
  }

  public displayDetailLabel(key, moduleCode?, displayMode?) {
    if (displayMode && moduleCode && (_.toLower(moduleCode) == 'wurm') && (_.toLower(key) == 'username')) {
      return 'LABEL_WEB_USER';
    }
    else if (displayMode && moduleCode && (_.toLower(moduleCode) == 'wurm') && (_.toLower(key) == 'fullname')) {
      return 'LABEL_RECIPIENT';
    }
    else if (moduleCode && (_.toLower(moduleCode) === 'dvm' && (_.toLower(key) == 'code'))) {
      return 'LABEL_SERIAL_NUMBER'
    }
    else {
      return 'LABEL_' + _.toUpper(key);
    }
  }

  public validateNumberPattern(model) {
    if (model) {
      let regex = new RegExp('^-?[0-9]*$')
      let result: Boolean = regex.test(model)
      return !result;
    }
    return false;
  }

  public validateMinQty(model) {
    return _.isFinite(_.toNumber(model)) && parseInt(model) < 1;
  }

  public regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  public greaterThanTo(control: FormControl) {
    if (control.value && control.parent.value['to']) {
      return parseInt(control.value) > parseInt(control.parent.value['to']) ? { 'greaterThanTo': true } : null;
    }
  }

  public greaterThanMax(control: FormControl) {
    if (control.value && control.parent.value['max']) {
      return parseInt(control.value) > parseInt(control.parent.value['max']) ? { 'greaterThanMax': true } : null;
    }
  }

  public greaterThanMin(control: FormControl) {
    if (control.parent) {
      if (control.value && control.parent.controls['min']) {
        return parseInt(control.value) < parseInt(control.parent.controls['min'].value) ? { 'greaterThanMin': true } : null;
      }
    }
  }

  public downloadThruEmailNotif() {
    this.dialogService.openDialog(ConfirmDialogComponent, {
      width: "400px",
      autoFocus: true,
      disableClose: true,
      data: {
        title: this.languageService.getTranslation("LABEL_DOWNLOAD_BY_EMAIL", {}),
        message: this.languageService.getTranslation("MSG_DOWNLOAD_BY_EMAIL", {}),
        button: this.languageService.getTranslation("LABEL_OK", {}),
        hasCancel: false,
      }
    });
  }

  public openDownloadMenu(data) {
    let url = _.get(data, 'presigned_url') || _.get(data, 'data');
    if (url) {
      window.open(url, '_blank');
    }
    else {
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NO_URL", {}))
    }
  }

  public chooseFile(ev, inputElement, excelColumns?, folderName?) {
    if (ev.target.files[0].type == 'application/vnd.ms-excel' || ev.target.files[0].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.fileToUpload = _.get(ev.target, 'files[0]');
      if (!excelColumns && !folderName) {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOAD_FILE", {}));
      }
      else {
        this.validateExcelHeaders(excelColumns, folderName)
      }
    } else {
      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INVALID_FILE_FORMAT", { format: '.xlsx' }));
      this.fileToUpload = null;
      inputElement.value = "";
    }
  }

  public validateExcelHeaders(excelColumns, folderName) {
    // console.log("excelColumns: ", excelColumns)
    this.hasUploaded.next(false);
    let loadingDialogRef = this.dialogService.loading();
    this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_VALIDATING", {}));
    let files = this.fileToUpload;
    let reader = new FileReader();
    reader.readAsBinaryString(files);
    reader.onload = (e) => {
      let data = e.target['result'];
      let workbook = XLSX.read(data, { type: 'binary' });
      let sheetName = workbook.SheetNames[0];
      let sheetObj = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: "" });

      if (!sheetObj.length) {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_EMPTY_FILE", {}));
        loadingDialogRef.close();
        this.fileToUpload = null;
        return;
      }

      let keys = Object.keys(sheetObj[0]).filter(e => {
        return !_.toLower(e).includes("empty") && (e != "") && (e != " ") && (e != null)
      });
      // console.log(keys, excelColumns)
      if (keys.length != excelColumns.length) {
        this.dialogService.openDialog(UploadColumnErrorComponent, {
          width: "400px",
          autoFocus: true,
          disableClose: true,
          data: {
            title: this.languageService.getTranslation("LABEL_INCORRECT_COLUMNS_NUM", {}),
            message: this.languageService.getTranslation("LABEL_EXPECTED_COLUMNS_1", {}) + excelColumns.join(", ") + this.languageService.getTranslation("LABEL_EXPECTED_COLUMNS_2", {}) + keys.join(", "),
            hasCancel: false,
            expectedColumns: excelColumns,
            columnsInFile: keys,
            button: this.languageService.getTranslation("LABEL_YES", {}),
            cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
          }
        })

        loadingDialogRef.close();
        this.fileToUpload = null;
        return;
      }

      for (let i in keys) {
        if (excelColumns.indexOf(keys[i]) < 0) {
          this.dialogService.openDialog(UploadColumnErrorComponent, {
            width: "400px",
            autoFocus: true,
            disableClose: true,
            data: {
              title: this.languageService.getTranslation("LABEL_INCORRECT_COLUMNS_NAME", {}),
              message: this.languageService.getTranslation("LABEL_EXPECTED_COLUMNS_1", {}) + excelColumns.join(", ") + this.languageService.getTranslation("LABEL_EXPECTED_COLUMNS_2", {}) + keys.join(", "),
              hasCancel: false,
              expectedColumns: excelColumns,
              columnsInFile: keys
            }
          })
          loadingDialogRef.close();
          this.fileToUpload = null;
          return;
        }
      }

      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_PLEASE_WAIT", {}));
      loadingDialogRef.close();
      this.uploadFile(folderName, this.fileToUpload);
    }
  }

  public validateAllocationExcelHeaders(excelColumns, folderName) {
    this.hasUploaded.next(false);

    let loadingDialogRef = this.dialogService.loading();
    this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_VALIDATING", {}));
    let files = this.fileToUpload;
    let reader = new FileReader();
    reader.readAsBinaryString(files);
    reader.onload = (e) => {
      let data = e.target['result'];
      let workbook = XLSX.read(data, { type: 'binary' });
      let sheetName = workbook.SheetNames[0];
      let sheetObj = workbook.Sheets[sheetName];

      let lvl1HeaderCells = ['A1', 'A2', 'A3', 'A4'];
      let lvl1HeaderCellValues = ['B1', 'B2', 'B3', 'B4'];
      let lvl1DetailCells = ['A6', 'B6', 'C6'];
      let lvl1DetailValues = ['A7', 'B7'];

      let lvl2HeaderCells = _.map(lvl1HeaderCells, _.clone);
      let lvl2HeaderCellValues = _.map(lvl1HeaderCellValues, _.clone);
      let lvl2DetailCells = ['A6', 'B6', 'C6', 'D6', 'E6'];
      let lvl2DetailValues = ['A7', 'B7', 'C7', 'D7'];

      let invalidColumns = checkIfCellsExist(sheetObj, lvl1HeaderCells, lvl1DetailCells, lvl2HeaderCells, lvl2DetailCells);

      if (invalidColumns) {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INVALID_TEMPLATE_S", {}));
        loadingDialogRef.close();
        this.fileToUpload = null;
        return;
      }

      let noValues = checkIfEmpty(sheetObj, lvl1HeaderCellValues, lvl2HeaderCellValues, lvl1DetailValues, lvl2DetailValues);

      if (noValues) {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INPUT_HDR_DETAIL", {}));
        loadingDialogRef.close();
        this.fileToUpload = null;
        return;
      }

      this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_PLEASE_WAIT", {}));
      loadingDialogRef.close();
      this.uploadFile(folderName, this.fileToUpload);
    }

    function checkIfCellsExist(sheetObj, lvl1HeaderCells, lvl1DetailCells, lvl2HeaderCells, lvl2DetailCells) {
      if (folderName == USER_ALLOC_UPLOAD_FOLDERNAME) {
        for (let a in lvl1HeaderCells) {
          if (!_.get(sheetObj[lvl1HeaderCells[a]], 'v') || (_.get(sheetObj[lvl1HeaderCells[a]], 'v') != excelColumns.header[a])) {
            return true;
          }
        }
        for (let a in lvl1DetailCells) {
          if (!_.get(sheetObj[lvl1DetailCells[a]], 'v') || (_.get(sheetObj[lvl1DetailCells[a]], 'v') != excelColumns.detail[a])) {
            return true;
          }
        }
      }
      else if (folderName == RECIPIENT_ALLOC_UPLOAD_FOLDERNAME) {
        for (let a in lvl2HeaderCells) {
          if (!_.get(sheetObj[lvl2HeaderCells[a]], 'v') || (_.get(sheetObj[lvl2HeaderCells[a]], 'v') != excelColumns.header[a])) {
            return true;
          }
        }
        for (let a in lvl2DetailCells) {
          if (!_.get(sheetObj[lvl2DetailCells[a]], 'v') || (_.get(sheetObj[lvl2DetailCells[a]], 'v') != excelColumns.detail[a])) {
            return true;
          }
        }
      }
      return false;
    }

    function checkIfEmpty(sheetObj, lvl1HeaderCellValues, lvl2HeaderCellValues, lvl1DetailValues, lvl2DetailValues) {
      if (folderName == USER_ALLOC_UPLOAD_FOLDERNAME) {
        for (let a in lvl1HeaderCellValues) {
          if (!_.get(sheetObj[lvl1HeaderCellValues[a]], 'v') || (_.get(sheetObj[lvl1HeaderCellValues[a]], 'v') == "")) {
            return true;
          }
        }
        for (let a in lvl1DetailValues) {
          if (!_.get(sheetObj[lvl1DetailValues[a]], 'v') || (_.get(sheetObj[lvl1DetailValues[a]], 'v') == "")) {
            return true;
          }
        }
      }
      else if (folderName == RECIPIENT_ALLOC_UPLOAD_FOLDERNAME) {
        for (let a in lvl2HeaderCellValues) {
          if (!_.get(sheetObj[lvl2HeaderCellValues[a]], 'v') || (_.get(sheetObj[lvl2HeaderCellValues[a]], 'v') == "")) {
            return true;
          }
        }
        for (let a in lvl2DetailValues) {
          if (!_.get(sheetObj[lvl2DetailValues[a]], 'v') || (_.get(sheetObj[lvl2DetailValues[a]], 'v') == "")) {
            return true;
          }
        }
      }
      return false;
    }
  }

  public uploadFile(folderName, fileToUpload?) {
    let loadingDialogRef = this.dialogService.loading();

    let tempObj = {
      folderName: folderName,
      file: fileToUpload ? fileToUpload : this.fileToUpload,
    }

    this.s3.upload(tempObj, (err, res) => {
      if (err) {
        if (environment.showLogs) {
          console.log("Error uploading: ", err);
        }
        loadingDialogRef.close();
        this.dialogService.confirm({
          title: "UPLOAD FAILED",
          message: this.languageService.getTranslation("MSG_UPLOADING_FAILED", {}),
          button: "Close",
          hasCancel: false
        });
       // this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_UPLOADING_FAILED", {}));
        return err;
      }
      else if (res) {
        if (environment.showLogs) {
          console.log("success: ", res);
        }

        loadingDialogRef.close();
        this.fileToUpload = null;
        this.hasUploaded.next({ s3Key: res, file: fileToUpload });
      }
    })
  }

  public checkIfObject(control: FormControl) {
    return _.isObject(control.value) ? null : { "notExisting": true };
  }

  public getUTC() {
    let utc = new Date().getTimezoneOffset() / 60;
    let utcString;
    if (utc <= 0) {
      if (utc > -10) {
        utcString = "+0" + Math.abs(utc) + ":00";
      } else {
        utcString = "+" + Math.abs(utc) + ":00";
      }
    } else {
      if (utc < 10) {
        utcString = "-0" + Math.abs(utc) + ":00";
      } else {
        utcString = "-" + Math.abs(utc) + ":00";
      }
    }
    return utcString;
  }


  public getActualUtc() {
    let utc = new Date().getTimezoneOffset() / 60;
    let utcString;

    /*
    * utc multiplied by two bec date time received is already considered local time even if it is supposed to be UTC +0
    */
    utc = utc * 2;
    if (utc <= 0) {
      if (utc > -10) {
        utcString = "+0" + Math.abs(utc) + "00";
      } else {
        utcString = "+" + Math.abs(utc) + "00";
      }
    } else {
      if (utc < 10) {
        utcString = "-0" + Math.abs(utc) + "00";
      } else {
        utcString = "-" + Math.abs(utc) + "00";
      }
    }
    return utcString;
  }

  public isUserCanSwitchCompany(): boolean {
    const value = localStorage.getItem("isUserCanSwitchCompany");
    // returns true only if the string is "true"
    // localStorage stores all values as strings, so we need to compare against the string 'true'
    return value === 'true'; 
  }
  
  public isUserAdmin() {
    let userRole = _.toLower(localStorage.getItem("userRole"));
    return userRole == 'admin';
  }

  public isUserRoot() {
    let userRole = _.toLower(localStorage.getItem("userRole"));
    return userRole == 'root';
  }

  public isUserMedrep() {
    let userRole = _.toLower(localStorage.getItem("userRole"));
    return userRole == 'medrep';
  }

  public isGlobalSchema() {
    let schema = _.toLower(localStorage.getItem("schemaName"));
    return schema.includes('global');
  }

  public hasSeenCompanyList() {
    let hasSeenCompanyList = localStorage.getItem("hasSeenCompanyList");
    return hasSeenCompanyList ?? false;
  }

  public networkErrorMessage() {
    return this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {}));
  }

  public reportGenerated() {
    // return this.dialogService.openSnackBar("Requested generation of report. Please check the Download Manager for the status.", null, 5000);
    return this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_REPORT_GENERATION", {}), null, 5000);
  }

  public isDataChanged(a, b) {
    if (a != b) {
      return true;
    }
    return false;
  }

  public displayErrorMessage(res) {
    if ((_.has(res, 'code') && (
      _.get(res, 'code').includes('0000') || 
      _.get(res, 'code').includes('1207') || 
      _.get(res, 'code').includes('0107') || 
      _.get(res, 'code').includes('207x5407') ||
      _.get(res, 'code').includes('7407') || 
      _.get(res, 'code').includes('005') || 
      _.get(res, 'code').includes('003') || 
      _.get(res, 'code').includes('7292') || 
      _.get(res, 'code').includes('7892') || 
      _.get(res, 'code').includes('7993') || 
      _.get(res, 'code').includes('0185') || 
      _.get(res, 'code').includes('0184') || 
      _.get(res, 'code').includes('004') 
    )) || (_.has(res, 'error.count') && (_.get(res, 'error.count') > 0) && (
      _.get(res, 'error.results[0].code').includes('004') ||
      _.get(res, 'error.results[0].code').includes('7292') ||
      _.get(res, 'error.results[0].code').includes('7892') ||
      _.get(res, 'error.results[0].code').includes('0185') ||
      _.get(res, 'error.results[0].code').includes('0184') ||
      _.get(res, 'error.results[0].code').includes('7993') ||
      _.get(res, 'error.results[0].code').includes('005')
    ))) {
      this.dialogService.openSnackBar(_.get(res, 'value') || _.get(res, 'error.results[0].value'));
      return true;
    }
    return false;
  }

  reportFilterGet(data, defaultVal) {
    if (data && _.isPlainObject(data)) {
      return ((data && data.code == 'all') ? [0] : defaultVal)
    }
    if (data && _.isArray(data)) {
      return _.size(data) > 0 ? data : defaultVal
    }
    return defaultVal
  }

  storeLocalData(res, username) {
    localStorage.setItem("userId", _.get(res.data, 'user_id'));
    localStorage.setItem("userName", username);
    localStorage.setItem("fullname", _.get(res.data, 'fullname'));
    localStorage.setItem("userRole", _.get(res.data, 'role.code'));
    localStorage.setItem("userRoleId", _.get(res.data, 'role.id'));
    localStorage.setItem("role", _.has(res.data, 'role') ? JSON.stringify(_.get(res.data, 'role')) : null );
    localStorage.setItem("company", _.has(res.data, 'company') ? JSON.stringify(_.get(res.data, 'company')) : null );
    localStorage.setItem("schemaName", _.get(res.data, 'schema_name'));
    localStorage.setItem("userDetails", _.get(res.data, 'jwt_token'));
    localStorage.setItem("escTimezone", mtz.tz.guess())
    localStorage.setItem("settings", _.get(res.data, 'settings') ? JSON.stringify(_.get(res.data, 'settings')) : null )
    localStorage.setItem("isUserCanSwitchCompany", _.has(res.data, 'is_user_can_switch_company') ?  _.get(res.data, 'is_user_can_switch_company') : false)
  }

  storePermissions(res) {
    localStorage.setItem("permission", _.get(res.data, 'module_permission').map(e => {
      return _.get(e, 'permission');
    }));
  }

  getCompanyName() {
    let company = JSON.parse(localStorage.getItem("company"))
    // return localStorage.getItem("schemaName");
    return _.get(company, 'description');
  }

  // Dev notes (Jeriel): returns an observable so other devs can expand on the functionality of post-processing results from dialog, such as subscribing to the observable, or converting into a promise
  processOTP(recipient: string, type: string, rec_name: string , skippable: boolean, schema_code: string): Observable<any> {
    return this.dialogService.openDialog(OtpDialogComponent, {
      width: "400px",
      autoFocus: true,
      disableClose: true,
      data: {
        recipient: recipient,
        type: type,
        name: rec_name,
        skippable: skippable,
        schema_code: schema_code
      }
    }).afterClosed()
  }

  // Replace None from python host responses into null values
  sanitizePythonNone(data?: any) {
    try {
      for (var key in data) {
        if (data[key] != null && data[key].toString().toLowerCase() == 'none') {
          data[key] = null
        }
      }

      return data
    } catch(err) {
      console.error(err)
    }
  }

  deepSortedEqual(obj1: Object, obj2: Object) {
    const deepNormalize = (obj: any) => {
      const normalized = _.cloneDeep(obj);
      Object.keys(normalized).forEach((key) => {
        if (Array.isArray(normalized[key])) {
          // Sort arrays to ensure consistent order
          normalized[key] = _.sortBy(normalized[key]);
        }
      });
      return normalized;
    };

    return _.isEqual(deepNormalize(obj1), deepNormalize(obj2));
  }

  getTextBefore(text: string, keyword: string): string {
    const parts = text.split(keyword);
    return parts[0] || ''
  }

  getTextAfter(text: string, keyword: string): string {
    const parts = text.split(keyword);
    return parts[1] || ''
  }

  getValueWithDefault(value, defaultValue) {
    return value ? value : defaultValue;
  }

  /**
 * Formats a datetime string to 'MMMM DD, YYYY hh:mm A' (e.g., 'June 02, 2025 12:21 AM').
 * @param datetime - A string in the format 'YYYY-MM-DD HH:mm:ss'.
 * @returns Formatted date string.
 */
  formatReadableDatetime(datetime: string): string {
    return moment(datetime).format('MMMM DD, YYYY hh:mm A');
  }
}
